

import React, { memo } from 'react';
import ButtonFactory from './ButtonFactory';


function Button({ children, ...props }) {
  return <button type="button" {...props}>{children}</button>;
}

export default memo(ButtonFactory(Button));